import { Stack } from "@mui/material";
import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  usersPageCloseModal,
  usersPageInit,
  usersPageMenuInit,
  usersPageStoreInit,
  usersXStoreInit,
  usersXVariablesInit,
  userXMenuInit,
} from "./reducers/users-page-actions";
import { Body1, Icone, Tab } from "../../../components";
import { selectUsersModal } from "./users-selectors";
import DrawerDialog from "../../../extra-components/drawer-dialog";
import UsersPageModal from "./users-page-modal";
import UsersTab from "./usuarios-tab/users-tab";
import { usersPageVariableInit } from "./reducers/users-page-variable-actions";
import VariaveisTab from "./variaveis-tab/variaveis-tab";
import GlobalVariavelTab from "./global-variavel-tab/global-variavel-tab";
import { usersPageGlobalVariableInit } from "./reducers/users-page-global-variable-actions";

const STR = {
  tab1: "Usuários",
  tab2: "Variáveis",
  tab3: "Váriaveis Globais",
};

function UsersPage() {
  const dispatch = useDispatch();
  const modal = useSelector(selectUsersModal);
  //
  useEffect(() => {
    dispatch(usersPageInit());
    dispatch(usersPageVariableInit());
    dispatch(usersPageGlobalVariableInit());
    dispatch(usersXVariablesInit());
    dispatch(usersPageMenuInit());
    dispatch(userXMenuInit());
    dispatch(usersPageStoreInit());
    dispatch(usersXStoreInit());
  }, [dispatch]);
  //
  const onCloseModal = useCallback(() => {
    dispatch(usersPageCloseModal());
  }, [dispatch]);
  //
  return (
    <>
      {modal && (
        <DrawerDialog
          fnGetCorpo={() => <UsersPageModal modal={modal} />}
          fecharModal={onCloseModal}
        />
      )}
      <TabsUsers />
    </>
  );
}

const TabsUsers = () => {
  const header = [
    {
      label: STR.tab1,
      icon: "Person",
    },
    {
      label: STR.tab2,
      icon: "Mediation",
    },
    {
      label: STR.tab3,
      icon: "Public",
    },
  ].map((ele) => (
    <Stack direction="row" gap={1} alignItems="center">
      <Icone icone={ele.icon} />
      <Body1>{ele.label}</Body1>
    </Stack>
  ));
  const body = [<UsersTab />, <VariaveisTab />, <GlobalVariavelTab />];

  return <Tab cabe={header} corpo={body} />;
};

UsersPage.route = "/usuarios";

export default UsersPage;
